import { Link } from 'react-router-dom'
import { Card } from 'react-bootstrap'
import Rating from './Rating'

const Product = ({ product }) => {
  return (
    <Card className='my-3 p-3 rounded white-glassmorphism'>
        <Link to={`/product/${product._id}`}>
            <Card.Img src={product.image} variant='top' />
        </Link>
        {/* <Card.Body> */}
        <Card.Body className='white-glassmorphism'>
            <Link to={`/product/${product._id}`}>
                <Card.Title as='div'>
                    <strong className='text-white'>{product.name}</strong>
                </Card.Title>
            </Link>

            <Card.Text className='text-white' as='div'>
                {/* <div className='my-3'>
                    {product.rating} from {product.numReviews} reviews
                </div> */}
                <Rating value={product.rating} text={`${product.numReviews} reviews`}/>
            </Card.Text>
            <Card.Text className='text-white' as='h3'>${product.price}</Card.Text>
        </Card.Body>
    </Card>
  )
}
export default Product